var module = angular.module('octopusApp.shared');

module.directive('deleteButton', function (octoDialog, octopusClient, unsavedChanges, $location) {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      model: '=',
      what: '@',
      redirect: "@"
    },
    template: '<a class="delete-button btn" href="" title="Delete" ng-show="canDelete" ng-click="deleteItem()">Delete</a>',
    link: function(scope, element, attr) {
      scope.$watch("model", function () {
        scope.canDelete = (scope.model && scope.model.Links && scope.model.Links.Self);
      });

      scope.deleteItem = function () {
        var dlg = octoDialog.confirmDelete(scope.what, function() {
          return octopusClient.del(scope.model.Links.Self);
        });
        dlg.then(function(result) {
          if (result) {
            unsavedChanges.saved();
            $location.path(scope.redirect);
          }
        });
      };
    }
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/delete_button.js
// module id = 4419749374579139
// module chunks = 1